import React from "react";
import { Link } from "react-router-dom";
import { Table } from "react-bootstrap";

import DataGroup from "../../DataGroup/DataGroup";

const PracticeProviders = (props) => {

    const providerRecords = props.providers.map((provider, index) => {
        const is_acp = provider.is_acp;
        const is_bookable  = provider.is_bookable ? 'Yes' : 'No';
        const is_pcp = provider.is_pcp;
        const is_staff = provider.is_staff ? 'Yes' : 'No';
        const is_online_scheduling  = provider.is_online_scheduling ? 'Yes' : 'No';
        const is_online_rescheduling  = provider.is_online_rescheduling ? 'Yes' : 'No';
        const is_telehealth_available  = provider.is_telehealth_available ? 'Yes' : 'No';
    
        return (
            <tr key={index}>
                <td nowrap="nowrap">
                    <Link to={{ pathname: "/provider/" + provider.id }} target="_blank">{provider.fullname}</Link>
                </td>
                <td>{is_staff}</td>
                <td>{(is_pcp && "PCP") || (is_acp && "ACP") || "Neither"}</td>
                <td>{is_bookable}</td>
                <td>{is_online_scheduling}</td>
                <td>{is_online_rescheduling}</td>
                <td>{is_telehealth_available}</td>
            </tr>
        );
    });

    return (
        <DataGroup title="Providers at this practice">
            <Table bordered>
                <thead>
                    <tr>
                        <th nowrap="nowrap">Provider</th>
                        <th nowrap="nowrap">NHPP</th>
                        <th nowrap="nowrap">PCP / ACP</th>
                        <th nowrap="nowrap">Bookable</th>
                        <th nowrap="nowrap">Schedule Online</th>
                        <th nowrap="nowrap">Reschedule Online</th>
                        <th nowrap="nowrap">Telehealth</th>
                    </tr>
                </thead>
                <tbody>
                    {providerRecords}
                </tbody>
            </Table>
        </DataGroup>
    );
}

export default PracticeProviders;